
  var categories = [
    { title: "Adidas Chile 62", url: "https://vintager2.de/collections/adidas-chile-62-trainingsjacken-trainingshosen-trainingsanzuege", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/Adidas_Chile_62_Vintage_Kollektion_Jacken_Hosen_und_Trainingsanzuege_comp.jpg?v=1788609270" },
    { title: "Lacoste Vintage Kollektion", url: "https://vintager2.de/collections/lacoste-vintage", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/Lacoste-Vintage-Kollektion.webp?v=1784232668" },
    { title: "Nike Vintage Kollektion", url: "https://vintager2.de/collections/nike-vintage", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/Nike_Vintage_Kolletkion.webp?v=1784232545" },
    { title: "Adidas Vintage Kollektion", url: "https://vintager2.de/collections/adidas-vintage", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/Adidas-Vintage-Kollektion.webp?v=1784232647" },
    { title: "Ralph Lauren Vintage", url: "https://vintager2.de/collections/polo-ralph-lauren-vintage", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/Ralph-Lauren-Kollektion.webp?v=1784283844" },
    { title: "Chief Keef Polos", url: "https://vintager2.de/collections/chief-keef-polo-shirts", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/0008_Chief_Keef_Polo_Shirts_von_Ralph_Lauren_wie_New_York_Brasilien_und_mehr.jpg?v=1788600678" },
    { title: "Vintage Fußball Trainingsjacken", url: "https://vintager2.de/collections/vintage-fussball-trainingsjacken", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/Vintage_Fussball_Trainingsjacken_von_Adidas_und_Nike_wie_Manchester_Argentinine_Marseille_und_viele_mehr.jpg?v=1788608956" },
    { title: "Vintage Tracksuits", url: "https://vintager2.de/collections/vintage-tracksuits", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/0005_Vintage_Tracksuits_wie_Marseille_oder_Firebird_und_mehr.jpg?v=1788600678" },
    { title: "Vintage Hoodies & Zipper", url: "https://vintager2.de/collections/vintage-hoodies-und-zipper", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/0002_Zipper_und_Hoodie_Vintage_Adidas_Ralph_Lauren_und_mehr.jpg?v=1788600678" },
    { title: "Vintage Trackjackets", url: "https://vintager2.de/collections/vintage-trackjackets", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/0010_Vintage_Trainingsjacke_Trackjackets_Nike_Adidas_Lacoste_Fred_Perry_und_mehr.jpg?v=1788600678" },
    { title: "Vintage Trikots", url: "https://vintager2.de/collections/vintage-fussball-trikots", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/0006_Vintage_Trikots_wie_Adidas_Real_Madrid_Marseille_Retro_Jerseys_und_mehr.jpg?v=1788600678" },
    { title: "Vintage Polos & T-Shirts", url: "https://vintager2.de/collections/vintage-t-shirts-polo-shirts-longsleeves", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/0011_Vintage_T-Shirts_von_Ralph_Lauren_und_Prada_Nike_und_viele_mehr_wie_Rugby_Polo_Shirts.jpg?v=1788600679" },
    { title: "Vintage Adidas Trainingsjacken", url: "https://vintager2.de/collections/vintage-adidas-trainingsjacken", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/0007_Adidas_Firebird_Vintage_Kollektion.jpg?v=1788600678" },
    { title: "Vintage Windbreaker & Jacken", url: "https://vintager2.de/collections/vintage-windbreaker-regenjacken-ubergangsjacken", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/0012_Leichte_Jacke_Harrington_von_Ralph_Lauren_Fred_Perry2.jpg?v=1788600678" },
    { title: "Vintage Pants & Cargos", url: "https://vintager2.de/collections/vintage-jeans-cargos-chinos", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/0004_Vintage_Jenas_wie_True_Religion_Levis_Victoria_Beckham_und_mehr2.jpg?v=1788600679" },
    { title: "Vintage Winterjacken", url: "https://vintager2.de/collections/vintage-pufferjacken", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/Vintage_Winterjacken_und_Westen_Gepufft_wie_Nike_Ralph_Lauren_und_mehr_e4525062-b01e-41dc-aae0-70402cc97b1e.jpg?v=1788609932" },
    { title: "Vintage Sweater & Pullover", url: "https://vintager2.de/collections/vintage-sweatshirts", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/0001_Vintage_Sweatshirts_von_Ralph_Lauren_Lacoste_und_mehr2.jpg?v=1788600678" },
    { title: "Vintage Trackpants", url: "https://vintager2.de/collections/vintage-trackpants", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/0003_Jogger_vintage_von_Adidas_und_mehr2.jpg?v=1788600678" },
    { title: "Nike TN Vintage", url: "https://vintager2.de/collections/nike-tn-vintage", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/0009_Nike_TN_Vintage_Kollektion_wie_Fleece_oder_Trainingsjacken_und_mehr.jpg?v=1788600679" },
    { title: "Vintage Fred Perry", url: "https://vintager2.de/collections/fred-perry", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/Fred-Perry-Kollektion.webp?v=1784283833" },
    { title: "Vintage Bags", url: "https://vintager2.de/collections/vintage-handtaschen-und-y2k-bags-guess-und-mehr", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/Guess-Vintage-Bags-Commercial-Shot-Flying-Collection-Image.jpg?v=1782765574" },
    { title: "D&G & Cavalli Tops", url: "https://vintager2.de/collections/d-g-cavalli-vintage-bustier-tanktop-camisole-neckholder-und-corsage-leo-satin-rosen", img: "https://cdn.shopify.com/s/files/1/0795/3498/1455/files/0000_D_G_Cavalli_und_mehr_Oberteile_Premium_Corsage_Bustier.jpg?v=1788600678" }
  ];


categories = categories.filter(cat => {
  return cat.url.replace(/\/$/, "").toLowerCase() !== currentCategory;
});


function getRandomCategories(list, count) {
  let selected = [];
  let available = [...list];
  
  while (selected.length < count && available.length > 0) {
    let index = Math.floor(Math.random() * available.length);
    selected.push(available.splice(index, 1)[0]);
  }
  return selected;
}

var selectedCategories = getRandomCategories(categories, 3);

function renderRandomCategories() {
  // Fest belegte Sale-Kachel nicht mit Zufallskategorien überschreiben
  const bannerElements = document.querySelectorAll(".product.banner:not([data-archive-sale-banner])");
  selectedCategories.forEach((category, index) => {
    if (bannerElements[index]) {
      const linkElement = bannerElements[index].querySelector(".animate-scale");
      const imageElement = bannerElements[index].querySelector(".collection-media img");
      const titleElement = bannerElements[index].querySelector(".title_with_logo");

      if (linkElement) linkElement.href = category.url;
      if (imageElement) {
        imageElement.src = category.img;
        imageElement.alt = category.title;
      }
      if (titleElement) titleElement.textContent = category.title;
    }
  });
}

function observeGridUpdates() {
  const grid = document.getElementById("CollectionProductGrid");
  if (!grid) return;

  let timeout;
  const observer = new MutationObserver(() => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      requestAnimationFrame(renderRandomCategories);
    }, 100); // debounce
  });

  observer.observe(grid, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", () => {
  renderRandomCategories();
  observeGridUpdates();
});




   /* var currentCategory = "{{ shop.url }}{{ collection.url }}";
  categories = categories.filter(cat => cat.url !== currentCategory);

  function getRandomCategories(list, count) {
    let shuffled = list.sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
  }

  var selectedCategories = getRandomCategories(categories, 3);

  document.addEventListener("DOMContentLoaded", function() {
    var bannerElements = document.querySelectorAll(".product.banner");
    selectedCategories.forEach((category, index) => {
      if (bannerElements[index]) {
        var linkElement = bannerElements[index].querySelector(".animate-scale");
        var imageElement = bannerElements[index].querySelector(".collection-media img");
        var titleElement = bannerElements[index].querySelector(".title_with_logo");
        
        if (linkElement) linkElement.href = category.url;
        if (imageElement) {
  imageElement.src = category.img;
  imageElement.alt = category.title;
}
        if (titleElement) titleElement.textContent = category.title;
      }
    });
  }); */
